import { render, staticRenderFns } from "./myMdTc.vue?vue&type=template&id=3eb047fa&scoped=true&"
import script from "./myMdTc.vue?vue&type=script&lang=js&"
export * from "./myMdTc.vue?vue&type=script&lang=js&"
import style0 from "./myMdTc.vue?vue&type=style&index=0&id=3eb047fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb047fa",
  null
  
)

export default component.exports